export default "__VITE_ASSET__a1efd85d__"